import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRight"><Path d="M14 5.5L20.5 12L14 18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20 12H3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRight;
